import ExternalRoutes from "Shared/Constants/ExternalRoutes";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import { EnvNames } from "Shared/env/envNames";
import { ServerError } from "@apollo/client";
import debounce from "lodash/debounce";

const RedirectHandlersMap: Record<number, () => void> = {
  401: () => {
    const source = window.location.href;
    window.location.assign(`${ExternalRoutes.login}?source=${source}`);
  },
  404: () => {
    window.location.assign(InternalRoutes.notFound);
  },
  403: () => {
    window.location.assign(InternalRoutes.restricted);
  },
  455: () => {
    window.location.assign(`${ExternalRoutes.authenticateDevice}`);
  },
};

export const SupportedErrorCodes = Object.keys(RedirectHandlersMap);

const handleServerError = debounce((serverError: ServerError, env: EnvNames) => {
  if (env !== "development") {
    const handler = RedirectHandlersMap[serverError.statusCode];
    handler && handler();
  }
}, 300, { leading: true, trailing: false });

export default handleServerError;
